// extracted by mini-css-extract-plugin
export var completionBody = "_gt-2";
export var completionCard = "_gt-0";
export var completionFooter = "_gt-3";
export var completionTitle = "_gt-1";